import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { CookieService } from 'ngx-cookie-service';
import { BaseApiService } from './base-api.service';
import { AuthenticationService } from './authentication.service';

@Injectable()
export class ProductService extends BaseApiService {
  constructor(
    private httpClient: HttpClient,
    private cookieService: CookieService,
  ) {
    super();
  }

  private baseUrl(): string {
    return this.apiUrl('/products');
  }

  private getHeaders() {
    let headers = new HttpHeaders();
    headers = headers.append('Accept', 'application/json');
    headers = headers.append('Content-Type', 'application/json');
    headers = headers.append(
      'Authorization',
      'Bearer ' + this.cookieService.get(AuthenticationService.sessionKey),
    );
    return { headers };
  }

  list(filters: Record<string, any> = {}) {
    let params = new HttpParams();
    Object.keys(filters).forEach((key) => {
      const value = filters[key];
      if (value !== null && value !== undefined && value !== '') {
        params = params.set(key, String(value));
      }
    });
    return this.httpClient.get<any>(this.baseUrl(), { ...this.getHeaders(), params });
  }

  get(id: string | number) {
    return this.httpClient.get<any>(`${this.baseUrl()}/${id}`, this.getHeaders());
  }

  create(payload: Record<string, any>) {
    return this.httpClient.post<any>(this.baseUrl(), payload, this.getHeaders());
  }

  update(id: string | number, payload: Record<string, any>) {
    return this.httpClient.put<any>(`${this.baseUrl()}/${id}`, payload, this.getHeaders());
  }

  delete(id: string | number) {
    return this.httpClient.delete<any>(`${this.baseUrl()}/${id}`, this.getHeaders());
  }

  sync(payload: Record<string, any> = {}) {
    return this.httpClient.post<any>(`${this.baseUrl()}/sync`, payload, this.getHeaders());
  }
}
